var map = {
	"./pr-1.png": "f8a1",
	"./pr-10.png": "9128",
	"./pr-11.png": "7e6d",
	"./pr-2.png": "d8b7",
	"./pr-3.png": "723b",
	"./pr-4.png": "7f64",
	"./pr-5.png": "9502",
	"./pr-6.png": "d86c",
	"./pr-7.png": "0382",
	"./pr-8.png": "18ec",
	"./pr-9.png": "07f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7408";